import * as Apollo from '@apollo/client'
import {
  GQL_AllOrganisationsForBoxPageQuery,
  GQL_AllOrganisationsForBoxPageQueryVariables,
  useAllOrganisationsForBoxPageQuery,
} from '../../../generated/graphql'

type BoxPageOrganisation = {
  id: string
  name: string
  boxes: Array<{id: string}>
}

export const useAllOrganisationsForBoxPage = (
  baseOptions?: Apollo.QueryHookOptions<GQL_AllOrganisationsForBoxPageQuery, GQL_AllOrganisationsForBoxPageQueryVariables>,
) => {
  const {data, ...rest} = useAllOrganisationsForBoxPageQuery(baseOptions)
  const allOrganisations = data?.organisation?.allOrganisations ?? []

  const sortedOrganisations: BoxPageOrganisation[] = [...allOrganisations]
    .map((organisation) => ({
      id: organisation.id,
      name: organisation.name,
      boxes: organisation.boxes.map((box) => ({id: box.id})),
    }))
    .sort((a, b) => a.name.localeCompare(b.name))

  return {
    ...rest,
    data: sortedOrganisations,
  }
}
